const state = {
  pages: [
    {
      title: "How It Works",
      route: "/how-it-works",
      isActivePage: false
    },
    {
      title: "Docs",
      route: "/docs",
      isActivePage: false
    },
    {
      title: "Pricing",
      route: "/pricing",
      isActivePage: false
    },
    {
      title: "Contact",
      route: "/contact",
      isActivePage: false
    }
  ],
  staticPages: [
    {
      title: "Terms of Use",
      route: "/terms-of-use",
      isActivePage: false
    },
    {
      title: "Privacy Policy",
      route: "/privacy",
      isActivePage: false
    },
    {
      title: "Community Guidelines",
      route: "/community-guidelines",
      isActivePage: false
    },
    {
      title: "Patents",
      route: "/patents",
      isActivePage: false
    }
  ],
  socials: [
    {
      name: "Facebook",
      url: "https://www.facebook.com/CrowdFlik",
      icon: "facebook",
      color: "is-facebook"
    },
    {
      name: "Twitter",
      url: "https://twitter.com/CrowdFlik",
      icon: "twitter",
      color: "is-twitter"
    },
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/company/crowdflik-inc-",
      icon: "linkedin",
      color: "is-linkedin"
    }
  ]
};

const mutations = {
  setActivePage(state, arg) {
    for (let i = 0; i < state.pages.length; i++) {
      if (state.pages[i].route === arg) {
        state.pages[i].isActivePage = true;
      } else {
        state.pages[i].isActivePage = false;
      }
    }
  },
  setActiveStaticPage(state, arg) {
    for (let i = 0; i < state.staticPages.length; i++) {
      if (state.staticPages[i].route === arg) {
        state.staticPages[i].isActivePage = true;
      } else {
        state.staticPages[i].isActivePage = false;
      }
    }
  }
};

const actions = {
  findActivePage({ commit }, arg) {
    commit("setActivePage", arg.path);
    commit("setActiveStaticPage", arg.path);
  }
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
